module.exports = __webpack_public_path__ + "img/ajoute_real.102eb918.png";